
import { handleResponse, authHeader } from './request';

async function signIn(email, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    };

    return fetch(`${process.env.VUE_APP_API_URL}/signin`, requestOptions)
        .then(handleResponse)
        .then(res => {
            if (res) {
                localStorage.setItem('user', JSON.stringify(res.user));
                localStorage.setItem('accessToken', JSON.stringify(res.accessToken));
            }
            return true;
        });
}

async function signUp(email, password, name, surname) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, name, surname })
    };

    return fetch(`${process.env.VUE_APP_API_URL}/signup`, requestOptions)

}

async function logOut() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');
    return
    
}
async function getMe() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${process.env.VUE_APP_API_URL}/me`, requestOptions)
        .then(handleResponse)

}

export default {
    signIn,
    signUp,
    getMe,
    logOut
};